'use strict';
import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

import EffectTinder from './effect-tinder.esm.js';
import liff from "@line/liff";
// ==============================================
// 定数
// ==============================================
const CONFIG = {
  LIFF_ID: process.env.LIFF_ID,
  LOGIN: process.env.LOGIN === 'true',
  // 新API (api2026 飲食店検索): POST {API2026_HOST}/api/fronts/{FRONT_ID}/chat
  API2026_HOST: (process.env.API2026_HOST || '').replace(/\/$/, ''),
  FRONT_ID: process.env.FRONT_ID || 'example-brand',
  // インテーク中の自由入力を API に判定させるか (OFF なら従来どおりクライアント完結)
  INTAKE_API: process.env.INTAKE_API === 'true',
  // 段階的に出すための割合 (0〜100)。未指定は 100。セッション単位で判定するので
  // 1つのインテークの途中で挙動が切り替わることはない
  INTAKE_API_RATE: (() => {
    const v = Number(process.env.INTAKE_API_RATE);
    return Number.isFinite(v) ? Math.min(100, Math.max(0, v)) : 100;
  })(),
  // LIFF ブラウザ (LINE アプリ内) 以外では使わせないか。
  // true のビルドは、外部ブラウザで開かれたら案内だけを出してアプリを開始しない
  REQUIRE_LIFF_BROWSER: process.env.REQUIRE_LIFF_BROWSER === 'true',
}
const ERROR_MESSAGE = "もう一度教えてくれるかナ？"
const TIMEOUT_MESSAGE = "ちょっと混み合っているみたいだゾ。少し待ってからもう一度試してほしいナ！"
const NETWORK_ERROR_MESSAGE = "通信エラーが起きてしまったナ。もう一度試してほしいゾ！"
const RETRY_BUTTON_LABEL = "もう一度試す"
// インテーク判定のタイムアウト。超えたら応答を捨ててフォールバックする
const INTAKE_TIMEOUT_MS = 8000
// 挨拶取得のタイムアウト。LLMを通らずDDBキャッシュを引くだけなので短めでよい。
// 超えたらエラー画面に落とす (代わりに出す文言を持っていないため)
const GREETING_TIMEOUT_MS = 5000
// インテーク判定に失敗したときの定型文 (条件は汚さない)。
// 失敗するのは判定を頼む通信であってユーザーの言い方ではないため、
// 「聞き取れなかった」とは言わない (doc reply14 §3-2)
const INTAKE_FALLBACK_NETWORK = "ウーム、うまく通信できなかったナ。もう一度送ってくれるかナ？"
// 同じステップで通算2回落ちたときの逃げ道。全断で会話が詰まるのを避けるため先へ進む
const INTAKE_FALLBACK_SKIP = "ウーム、うまく通信できなかったナ。ここは決めずに進めるゾ！"
// リセット (条件クリアしてヒアリングから再開) の表示ラベル。
// サーバ (api2026) は "検索をやり直す" というラベルで返してくるが、確認ステップの静的ボタン
// (index.html の data-meta="search_reset") と文言を揃えるため、フロント表示はこちらに差し替える
const RESET_BUTTON_LABEL = "別の条件で探したい"
// リセットをサーバへ送るときの文言。サーバ側 (api2026 の guidedFlow.js) の reset 判定に
// 合わせる必要があるため、表示ラベルとは分けて固定する
const RESET_SERVER_MESSAGE = "検索をやり直す"
// リセットの判定。サーバ側 (api2026 の guidedFlow.js) が前方一致→完全一致に変わったのに合わせる。
// 前方一致のままだと「検索をやり直すので渋谷にして」のような入力で後ろの条件が消える
// (末尾の句読点だけは許容する)
const RESET_PATTERN = /^検索をやり直す[。．、,！!？?\s]*$/
// リセットをサーバへ送信するか。
//   false: 送らずローカルだけで診断直後の状態に戻す (待ち時間ゼロ。既定)
//   true : サーバへ送ってから戻す (クエリログに記録が残るが応答を1〜2秒待つ)
// どちらも最終的な状態は同じ。session_id を捨てるためリセット応答を使わないので送信を省ける
const RESET_SENDS_TO_SERVER = false

// インテーク (条件ヒアリング) のセリフ。文言調整はここを編集する
// 最初の挨拶 (1〜2番目の吹き出し) だけはここに持たない。クライアントが管理画面で
// 編集できるよう api2026 側に移したため (GET /greeting)。フロントに控えを残すと
// 季節の文言が事故で表に出るので、意図的にフォールバックを置いていない
const INTAKE_MSG = {
  askPerson: "まずは、何人くらいの予定かナ？",
  askArea: "どのエリアで探すかナ？\n具体的な地名を教えてくれよナ。（例：新宿、渋谷、池袋など）",
  askAreaText: "行きたいエリアを入力してほしいナ！",
  askPrice: "一人あたりの予算はどれくらいかナ？",
  askOption: "こだわりはあるかナ？",
  confirmAsk: "この条件で探していいかナ？",
  // お昼希望なのに予算が未定のときに聞き直す文言 (夜より高いランチが上位に来るため)
  askLunchPrice: "お昼だと予算も変わるナ。いくらまでにするかナ？",
}
// ==============================================
// 変数
// ==============================================
const categories = [
  {
    category: '趣きたっぷり・味のある店',
    score:0
  }, {
    category: 'シンプルでスタイリッシュな空間',
    score:0
  }, {
    category: 'ラグジュアリーな雰囲気',
    score:0
  }, {
    category: '大人数でワイワイ',
    score:0
  }, {
    category: '異国情緒で非日常',
    score:0
  }, {
    category: 'その他',
    score:0
  }
]

// 新APIのセッションID。常にレスポンスの値で上書きする (「検索をやり直す」で再発行されるため固定持ち回りは不可)
let sessionId = null;
// リトライ用に最後に送った検索メッセージを保持
let lastSentMessage = "";
// インテーク (条件ヒアリング) の状態
let intake = null;
// 送信中の多重送信ガード (検索は最大30秒かかるため在飛行中の再送を防ぐ)
let isSending = false;
// インテーク中だけ使う一時ID。クエリログで「どんな雑談の後にどんな検索をしたか」を追うために送る
let intakeTraceId = null;
// インテーク判定の世代カウンタ。タイムアウト後に遅れて返った応答を捨てるために使う
let intakeSeq = 0;
// このインテークで API 判定を使うか。段階的リリース用にセッション単位で決める
let intakeApiEnabled = false;
// ==============================================
// LIFF関連
// ==============================================

/**
 * LIFFを初期化する
 * @returns {Promise<void>}
 */
const initializeLiff = async () => {
  await liff.init({ liffId: CONFIG.LIFF_ID });
};

/**
 * ログインコールバック後のURLパラメータをクリーンアップする
 * liff.login()から戻ってきた際に、URLに付与されたパラメータを削除
 */
const cleanupCallbackUrl = () => {
  if (window.location.hash || window.location.search.includes('liffClientId')) {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

/**
 * ログイン処理を実行する
 */
const handleLogin = () => {
  liff.login({withLoginOnExternalBrowser: true});
};

// ==============================================
// ユーザー情報関連
// ==============================================

/**
 * ユーザープロフィール情報を取得する
 * @returns {Promise<Object>} プロフィール情報
 */
const fetchUserProfile = async () => {
  return await liff.getProfile();
};

/**
 * プロフィール情報を画面に表示する
 * @param {Object} profile - ユーザープロフィール情報
 */
const displayUserProfile = (profile) => {
  const profileHtml = `
    <p><strong>名前:</strong> ${profile.displayName}</p>
    <p><strong>ユーザーID:</strong> ${profile.userId}</p>
    ${profile.pictureUrl ? `<img src="${profile.pictureUrl}" alt="プロフィール画像" style="width:100px;height:100px;border-radius:50%;">` : ''}
  `;

  $('#profile').html(profileHtml);
  $('#user-info').show();
};

// ==============================================
// UI更新
// ==============================================

/**
 * ステータスメッセージを更新する
 * @param {string} message - 表示するメッセージ
 */
const updateStatus = (message) => {
  $('#status').text(message);
};

/**
 * エラーメッセージを表示する
 * @param {Error} error - エラーオブジェクト
 */
const displayError = (error) => {
  console.error('LIFFエラー:', error);
  updateStatus(`エラー: ${error.message}`);
};

/**
 * LIFFブラウザ以外で開かれたときの案内を出す (REQUIRE_LIFF_BROWSER=true のビルドだけ)
 *
 * 判定は liff.init() の後でしか出せないので、ここに来た時点で SDK の初期化は済んでいる。
 * アプリ本体 (フリック・チャット) は開始せず、案内だけを残す
 */
const showLiffOnlyNotice = () => {
  sendEvent('liff_only_blocked', { in_client: false });
  $("section").addClass("hide");
  $("#liff-only").removeClass("hide");
};

/**
 * Google Analyticsにページビューイベントを送信する
 * @param {string} pageName - ページ名（例: 'LP', 'CHAT', 'MATCHING'）
 * @param {string} path - ページパス（例: '/lp', '/chat', '/matching'）
 */
const sendPageView = (pageName, path) => {
  // gtagが定義されているか確認
  if (typeof gtag !== 'undefined') {
    // ベースURLを取得
    const origin = window.location.origin;
    // pathnameから末尾のスラッシュを削除し、ルート(/)の場合は空文字列に
    const pathname = window.location.pathname === '/' ? '' : window.location.pathname.replace(/\/$/, '');
    const baseUrl = origin + pathname;

    gtag('event', 'page_view', {
      'page_title': pageName,
      'page_location': `${baseUrl}${path}`,
    });
  }
};

/**
 * Google Analyticsにカスタムイベントを送信する
 * @param {string} eventName - イベント名（例: 'button_click', 'form_submit', 'slider_swipe'）
 * @param {Object} params - イベントパラメータ（オプション）
 */
const sendEvent = (eventName, params = {}) => {
  // gtagが定義されているか確認
  if (typeof gtag !== 'undefined') {
    gtag('event', eventName, params);
  }
};

// ==============================================
// メイン処理
// ==============================================

/**
 * アプリケーションの初期化処理
 */
const liffInit = async () => {
  if(location.host === '192.168.11.6:8080') return false; // ローカル開発環境でLIFF初期化をスキップ
  try {
    // LIFF初期化
    await initializeLiff();

    // ステータス更新
    updateStatus('初期化完了');

    // LIFFブラウザ以外を弾くビルドか。外部ブラウザならログインもせず案内だけ出して止める
    if (CONFIG.REQUIRE_LIFF_BROWSER && !liff.isInClient()) {
      showLiffOnlyNotice();
      return true;
    }

    // ログイン状態確認と処理分岐
    if (liff.isLoggedIn()) {
      // ログイン済み: ユーザー情報を取得・表示
      const profile = await fetchUserProfile();
      displayUserProfile(profile);
      localStorage.setItem("user_id", profile.userId);
      // コールバックURLのクリーンアップ（ログイン確認後）
      cleanupCallbackUrl();
    } else {
      // 未ログイン: ログイン画面へ遷移
      handleLogin();
    }
    return false;

  } catch (error) {
    displayError(error);
    return false;
  }
};

const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

/**
 * リセット指示かどうかを判定する (ボタン押下・自由入力のどちらも submitSearch でここを通る)
 * サーバ文言は前方一致 (サーバ判定と同じ)、表示ラベルは完全一致のみ。
 * ラベルを前方一致にすると「別の条件で探したいんだけど渋谷で」のような自由入力まで
 * リセット扱いになり、追加条件を捨ててしまうため
 */
const isResetMessage = (message) => {
  const text = String(message == null ? "" : message).trim();
  return RESET_PATTERN.test(text) || text === RESET_BUTTON_LABEL;
};

/* Scene Manager */
const sceneManager = async (nextScene) => {
  $("section").addClass("hide");
  await sleep(300);
  switch (nextScene) {
    case "error":
      $("#error").removeClass("hide");
      break;
    case "matching":
      $("#matching").removeClass("hide");
      sendPageView("MATCHING","/matching");
      break;
    case "chat":
      // 飲食店検索 (新API): クライアント側インテークから開始
      $("#chat").removeClass("hide");
      sendPageView("CHAT-Restaurant","/chat/restaurant");
      await startRestaurantIntake();
      break;
  }
}

// ==============================================
// チャット描画 共通
// ==============================================

/**
 * メッセージをチャット表示用HTMLに整形する
 * (HTMLエスケープ + Markdown太字 + URLリンク化 + 改行変換)
 * 新APIの comment_bubbles はMarkdownを含むため最低限のレンダリングを行う
 */
const formatMessage = (message) => {
  let t = String(message)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  t = t.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  const urlPattern = /(https?:\/\/[^\s<>"]+)/g;
  t = t.replace(urlPattern, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
  // サーバ文言 (api2026 の管理画面でクライアントが入力する) に書かれた <br> だけは
  // 改行として通す。管理画面は「1行 = 1吹き出し」仕様で、1つの吹き出しの中で改行する
  // 手段が <br> しかないため。上でエスケープ済みなので、ここで戻すのは <br> のみ。
  // それ以外のタグは文字のまま表示される (HTMLとして解釈させない方針は維持)
  t = t.replace(/&lt;br\s*\/?&gt;/gi, '<br>');
  t = t.replace(/\n/g, '<br>');
  return t;
};

const addChatMessage = (message, isUser=true, think=false) => {
  const div = $("<div>").addClass(isUser ? "user-message" : "bot-message").addClass("chat-message");
  if(think){
    div.addClass("chat-thinking");
  }

  let formattedMessage = message;
  if (typeof message === 'string') {
    formattedMessage = formatMessage(message);
  }

  const p = $("<p>").html(formattedMessage)
  div.append(p);
  $("#chat-content-inner").append(div);
  scrollChatBottom();
}

const scrollChatBottom = () => {
  $("#chat-content").scrollTop($("#chat-content-inner").height());
}

/**
 * ボットのセリフを1吹き出しずつ間を空けて表示する
 * @param {string[]} messages
 */
const botSay = async (messages) => {
  for (const message of messages) {
    await sleep(1000);
    $(".chat-thinking").remove();
    addChatMessage(message, false, false);
    addChatMessage("", false, true);
  }
  $(".chat-thinking").remove();
};

/**
 * 店舗カードスライダーを生成する
 */
const buildSlider = (data, meal = "dinner") => {
  // ランチ検索のときは昼の予算を出す (results は昼夜とも返ってくる)
  const isLunch = meal === "lunch";
  const slider = $("<div>").addClass("bot-message chat-message slider");
  const suggestSlider = $("<div>").addClass("suggest-slider");
  for(const item of data){
    const slide = $("<div>").addClass("slide");
    const picture = $("<picture>");
    // 新APIは exterior_image_id から画像URLを組み立てる (doc/13 フロント統合ガイド)
    const imageUrl = item.exterior_image_id
      ? `https://tabelog.com/imgview/original?id=${item.exterior_image_id}`
      : (item.image_url || "./assets/images/dummy-pic1.jpg");
    // name に支店名が含まれている場合があるため、重複するときは branch_name を付けない
    let displayName = item.name || "";
    if (item.branch_name && !displayName.includes(item.branch_name)) {
      displayName = `${displayName} ${item.branch_name}`.trim();
    }
    if (!displayName) displayName = "(店名不明)";
    const img = $("<img>").attr("src", imageUrl).attr("alt", displayName);
    picture.append(img);
    const detail = $("<div>").addClass("detail");
    const name = $("<h1>").text(displayName);
    const address = $("<p>").addClass("address").text(item.address || "");
    detail.append(name, address);
    const telNumber = item.phone || item.tel || "";
    if (telNumber) {
      const tel = $("<a>").addClass("tel").attr("href", "tel:" + telNumber).text(telNumber).attr("data-name", displayName);
      detail.append(tel);
    }
    // 新APIには店舗ごとの紹介文がないため、主要情報からダイジェストを組み立てる
    const commentText = item.comment || [
      item.score ? `食べログ ${item.score}` : "",
      item.category || "",
      item.nearest_station ? `${item.nearest_station}最寄り` : "",
      (() => {
        const budget = isLunch ? item.budget_lunch : item.budget_dinner;
        return budget ? `${isLunch ? "昼予算" : "夜予算"} ${budget}` : "";
      })(),
    ].filter(Boolean).join("／");
    const comment = $("<p>").addClass("comment").text(commentText);
    const span = $("<span>").text("店舗情報");
    const linkUrl = item.tabelog_url || item.url || "";
    const a = $("<a>").attr("href", linkUrl).attr("target", "_blank").addClass("tab-link").append(span).attr("data-name", displayName);
    detail.append(comment, a);
    slide.append(picture, detail);
    suggestSlider.append(slide);
  }
  slider.append(suggestSlider);
  return slider;
}

// ==============================================
// 新API (api2026 飲食店検索)
// ==============================================

/**
 * 新APIにメッセージを送信する
 * @returns {Promise<{ok:boolean, data?:Object, error?:Object, timeout?:boolean}>}
 */
const callChatApi = async (message) => {
  const url = `${CONFIG.API2026_HOST}/api/fronts/${encodeURIComponent(CONFIG.FRONT_ID)}/chat`;
  const userId = getUserId();
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      message,
      ...(sessionId ? { session_id: sessionId } : {}),
      // インテークのターンと検索のターンを突き合わせるための一時ID
      ...(intakeTraceId ? { trace_id: intakeTraceId } : {}),
      ...(userId ? { user_id: userId } : {}),
    }),
  });
  // CloudFrontタイムアウト(30秒超)時はJSONでなくHTMLが返るため、textで受けて自前でパースする
  const raw = await res.text();
  let data;
  try {
    data = JSON.parse(raw);
  } catch (_) {
    return { ok: false, timeout: true };
  }
  if (!res.ok || !data.success) {
    return { ok: false, error: data.error };
  }
  // セッションIDは常にレスポンスの値を採用する
  sessionId = data.session_id;
  return { ok: true, data: data.data };
};

/**
 * 検索メッセージ送信の共通経路 (自由入力・選択肢ボタン・リトライすべてここを通る)
 *
 * リセット (「別の条件で探したい」) だけは応答の扱いが異なる。サーバは条件をクリアして
 * 新しい session_id を返すが、案内文 (「条件をリセットしたゾ！…」) は表示せず、
 * インテークを1問目から開始し直す
 */
const submitSearch = async (message, { echo = true, echoAs = null } = {}) => {
  if (isSending) return;
  const isReset = isResetMessage(message);
  // ユーザー吹き出しに出す文言。echoAs が指定されていればそれを優先する。
  // サーバの resend_message は合成クエリ全文を含むことがあるため、ボタン押下時は
  // ラベルを表示に使う (送信自体は resend_message のまま。ラベルで送ると条件が落ちる)
  const echoText = echoAs != null ? echoAs : (isReset ? RESET_BUTTON_LABEL : message);
  // 送信を省く設定なら API を叩かずその場で戻す (体感が速い)
  if (!RESET_SENDS_TO_SERVER && isReset) {
    if (echo) {
      addChatMessage(echoText, true);
    }
    await restartAfterReset();
    return;
  }
  isSending = true;
  $("#send-button").prop("disabled", true);
  // 再開は多重送信ガードを解除してから走らせたいのでフラグで持ち越す
  let restartIntake = false;
  try {
    intake = null; // 検索送信をもってインテークは終了
    if (echo) {
      addChatMessage(echoText, true);
    }
    addChatMessage("", false, true);
    // リセットはサーバの reset 判定に合う文言で送る (自由入力で表示ラベルを打たれた場合も同じ)
    const sendMessage = isReset ? RESET_SERVER_MESSAGE : message;
    lastSentMessage = sendMessage;
    let result;
    try {
      result = await callChatApi(sendMessage);
    } catch (err) {
      console.log('Error fetching :', err);
      result = { ok: false, network: true };
    }
    if (isReset && result.ok) {
      // リセット成功。案内文 (「条件をリセットしたゾ！…」) は出さない
      $(".chat-thinking").remove();
      restartIntake = true;
    } else {
      // 失敗時は通常どおりエラー表示 (リトライボタンも出る)
      await renderChatResponse(result);
    }
  } finally {
    isSending = false;
    $("#send-button").prop("disabled", false);
  }
  if (restartIntake) {
    await restartAfterReset();
  }
};

/**
 * リセット (「別の条件で探したい」) 後の状態復帰。
 * スワイプ診断直後 (sceneManager("chat")) と同じ状態に戻す。
 * ただしチャットの表示内容 (TL) はそのまま残す。
 */
const restartAfterReset = async () => {
  // session_id は捨てて null に戻す。診断直後は未発行の状態なのでそれに合わせる。
  // null なら callChatApi が session_id を送らず、次の検索でサーバが新規セッションを
  // 起こす (初回検索と同じ経路)。前セッションの条件・既出店舗は参照されなくなる
  sessionId = null;
  // リトライでリセットを再送してしまわないよう捨てる
  lastSentMessage = "";
  // 人数・エリア・予算等は startRestaurantIntake が intake を作り直すことで消える。
  // スワイプ診断の結果 (categories / localStorage "choices") は診断直後も保持されて
  // いる状態なので、ここでは消さない
  await startRestaurantIntake({ skipGreeting: true });
};

/**
 * 新APIレスポンスの描画。3パターンに対応する:
 *   A: 検索結果 (comment_bubbles + results)
 *   B: 確認質問 (clarification) → 選択肢ボタン
 *   C: 次アクション (actions) → 選択肢ボタン
 * BとCのoptionは同一形状のため共通レンダラ(showDynamicOptions)で描画する
 */
const renderChatResponse = async (result) => {
  if (!result.ok) {
    $(".chat-thinking").remove();
    let message = ERROR_MESSAGE;
    if (result.timeout) {
      message = TIMEOUT_MESSAGE;
    } else if (result.error && result.error.code === "RATE_LIMIT") {
      message = TIMEOUT_MESSAGE;
    } else if (result.error && result.error.message) {
      message = result.error.message;
    } else if (result.network) {
      message = NETWORK_ERROR_MESSAGE;
    }
    addChatMessage(message, false, false);
    sendEvent('error_process_failed');
    if (lastSentMessage) {
      // リトライはローカルアクション扱い (インテーク合成文を再エコーで露出させないため)
      showDynamicOptions([{ label: RETRY_BUTTON_LABEL, local_action: "retry", is_default: true }]);
    }
    return;
  }

  const data = result.data;
  // 1要素=1吹き出しで表示 (comment_bubbles が無い場合は comment にフォールバック。両方空の成功応答は吹き出しなし)
  const bubbles = (Array.isArray(data.comment_bubbles) && data.comment_bubbles.length)
    ? data.comment_bubbles
    : (data.comment && String(data.comment).trim() ? [data.comment] : []);
  if (bubbles.length) {
    await botSay(bubbles);
  } else {
    $(".chat-thinking").remove();
  }

  // 店舗カード (最後の吹き出しの下に表示)
  if (!data.clarification && Array.isArray(data.results) && data.results.length) {
    // 表示に使う食事帯 (reply11 §2: data.meal が正。定型応答でも正しい値が入る)
    const meal = data.meal || "dinner";
    const slider = buildSlider(data.results, meal);
    $("#chat-content-inner").append(slider);
    scrollChatBottom();
    data.results.forEach((restaurant) => {
      sendEvent('suggested_restaurant', {
        'event_category': 'restaurant_suggestion',
        'event_label': restaurant.name,
        'value': restaurant.tabelog_url
      });
    });
  }

  // 選択肢ボタン (clarification / actions は同一形状)
  const options = [];
  if (data.clarification && Array.isArray(data.clarification.options)) {
    options.push(...data.clarification.options);
  }
  if (data.actions && Array.isArray(data.actions.options)) {
    options.push(...data.actions.options);
  }
  if (options.length) {
    showDynamicOptions(options);
  }
};

/**
 * サーバ駆動の選択肢ボタンを動的に描画する
 * 押下時は resend_message を同一セッションでそのまま再送する (再送文の組み立てはサーバ側の責務)
 */
const showDynamicOptions = (options) => {
  const $group = $(".button-group.dynamic");
  $group.empty();
  for (const opt of options) {
    // サーバのリセット選択肢はラベルだけ差し替える (resend_message はサーバ判定用なのでそのまま)
    const isReset = isResetMessage(opt.resend_message || opt.label);
    const label = isReset ? RESET_BUTTON_LABEL : opt.label;
    const $btn = $("<button>").addClass("option-button dynamic").text(label);
    if (opt.is_default) $btn.addClass("is-default");
    if (opt.local_action) {
      $btn.attr("data-local-action", opt.local_action);
    } else {
      $btn.attr("data-resend", opt.resend_message);
    }
    $group.append($("<li>").append($btn));
  }
  const $container = $(".option-button-container");
  // 静的グループのクラスが残っていると動的ボタンと併存表示されるため先に除去する
  $container.removeClass("price place person option area area1 area2 area3 area4 area5 area6 area7 area8 search");
  $container.addClass("dynamic");
  // 選択肢の数によらず水平1列 + 横スクロールで表示する (検索結果後のアクションボタンと同じ挙動)。
  // 折り返し表示 (.wrap) は縦積みになりスワイプ操作と噛み合わないため使わない
  $("#chat-content-inner").removeClass("multiple-options");
  $container.addClass("active");
  scrollChatBottom();
};

// ==============================================
// インテーク (条件ヒアリング)
// 旧UIのシナリオ誘導 (人数→エリア→予算→こだわり→確認) をクライアント側で再現し、
// 収集した条件とスワイプ診断結果を自然言語にまとめて新APIへ送る
// ==============================================

/**
 * インテークの次の質問を表示する。botSay 待機中に自由入力などで
 * インテークが終了/再開された場合は、保留中の選択肢表示を中止する
 */
const askNext = async (messages, action) => {
  const myIntake = intake;
  await botSay(messages);
  if (intake !== myIntake) return;
  if (action) await optionManager(action);
};

// インテークの質問順。API から collected でまとめて条件が返った場合は、
// 埋まっていない最初の質問へジャンプする
const STEP_ORDER = ["person", "area", "price", "option"];

// こだわりが「お昼」を指しているか (ボタン・自由入力・API の言い換えのいずれも拾う)
const LUNCH_PATTERN = /ランチ|お昼|昼/;

/**
 * お昼希望なのに予算が「未定」のままかどうか。
 * 昼予算は夜より高い店が上位に来るため、未定のまま検索すると 1 万円超のランチが先頭に並ぶ
 */
const needsLunchBudget = () => (
  !intake.lunchBudgetAsked
  && LUNCH_PATTERN.test(intake.optionPhrase || "")
  && intake.filled.price
  && intake.pricePhrase === ""
);

const stepQuestion = (step) => ({
  person: INTAKE_MSG.askPerson,
  area: INTAKE_MSG.askArea,
  price: INTAKE_MSG.askPrice,
  option: INTAKE_MSG.askOption,
  confirm: INTAKE_MSG.confirmAsk,
}[step]);

// エリアは全国版のためサジェストボタンを出さず自由入力で受ける (action なし)
const stepAction = (step) => (step === "area" ? null : step);

/**
 * 指定ステップを質問する。say=false のときは質問文を言わず選択肢だけ出し直す
 * (API が返した吹き出しに質問の再掲が含まれている場合に使う)
 */
const askStep = async (step, { say = true } = {}) => {
  intake.step = step;
  intake.awaitText = (step === "area") ? "area" : null;
  if (say) {
    await askNext([stepQuestion(step)], stepAction(step));
    return;
  }
  const action = stepAction(step);
  if (action) await optionManager(action);
};

const goToConfirm = async ({ sayAsk = true } = {}) => {
  intake.step = "confirm";
  intake.awaitText = null;
  // sayAsk=false は、API 側の吹き出しに確認質問の再掲が既に含まれている場合。
  // 条件サマリだけ出し直して二重に聞かないようにする
  const messages = sayAsk ? [buildConfirmMessage(), INTAKE_MSG.confirmAsk] : [buildConfirmMessage()];
  await askNext(messages, "search");
};

/** まだ埋まっていない最初の質問へ進む。全部埋まっていれば確認ステップへ */
const goToNextStep = async () => {
  // お昼希望＋予算未定なら、先に昼の予算を聞き直す (1 回だけ。再度「未定」ならそのまま進む)
  if (needsLunchBudget()) {
    intake.lunchBudgetAsked = true;
    intake.filled.price = false;
    intake.priceLabel = "";
    intake.step = "price";
    intake.awaitText = null;
    await askNext([INTAKE_MSG.askLunchPrice], "price");
    return;
  }
  const next = STEP_ORDER.find((step) => !intake.filled[step]);
  if (!next) {
    await goToConfirm();
    return;
  }
  await askStep(next);
};

/** 予算の条件句から確認吹き出し用の短いラベルを作る (一人あたり予算は3,000円まで → 〜3,000円) */
const shortPriceLabel = (phrase) => {
  const m = String(phrase || "").match(/([0-9,]+)\s*円\s*(まで|以下|以上|から)/);
  if (!m) return phrase || "";
  return (m[2] === "以上" || m[2] === "から") ? `${m[1]}円〜` : `〜${m[1]}円`;
};

/**
 * API が返した collected をインテークの状態に反映する。
 * 読み取れた項目だけがキーとして入る (空文字は「未指定として確定」の意味)
 */
const applyCollected = (collected) => {
  if (!collected || typeof collected !== "object") return;
  if (typeof collected.person === "string") {
    intake.personLabel = collected.person;
    // 人数はサーバが 〜5人 / 〜10人 / それ以上 / 未定 の4値で返す。鉤括弧に包んで検索文に載せる
    intake.personPhrase = collected.person ? `予定人数は「${collected.person}」` : "";
    intake.filled.person = true;
  }
  // area は空文字で確定させない (エリア抜きの検索文になり、件数集計も「もっと探して」も出せなくなる)
  if (typeof collected.area === "string" && collected.area.trim() !== "") {
    intake.areaLabel = collected.area;
    intake.areaPhrase = collected.area;
    intake.filled.area = true;
  }
  if (typeof collected.price === "string") {
    // 空文字は「予算で絞らない」の意味。表示は人数の「未定」に揃える
    intake.priceLabel = collected.price ? shortPriceLabel(collected.price) : "未定";
    intake.pricePhrase = collected.price;
    intake.filled.price = true;
  }
  if (typeof collected.option === "string") {
    intake.optionLabel = collected.option;
    intake.optionPhrase = collected.option;
    intake.filled.option = true;
  }
};

/** 判定リクエストに載せる「ここまでに確定した条件」 */
const currentCollected = () => {
  const c = {};
  if (intake.filled.person) c.person = intake.personLabel;
  if (intake.filled.area) c.area = intake.areaPhrase;
  if (intake.filled.price) c.price = intake.pricePhrase;
  if (intake.filled.option) c.option = intake.optionPhrase;
  return c;
};

/**
 * クエリログに載せる LINE ユーザーID (LIFF の getProfile().userId)。
 * LOGIN=false やログイン前は localStorage に無いので、その場合は送らない
 * (API 側は未指定なら 'U12345678' を記録する)
 */
const getUserId = () => {
  const v = localStorage.getItem("user_id");
  return (typeof v === "string" && v.trim() !== "") ? v : null;
};

const newTraceId = () => {
  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  return `t-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
};

/**
 * 挨拶のパターンを決める。
 *   b: スワイプ診断を最後まで終えた (localStorage "choices" が書かれるのは完走時だけ)
 *   a: スキップ・途中離脱・判別できないとき (サーバ側も未知の値は a にフォールバックする)
 */
const greetingPattern = () => (localStorage.getItem("choices") ? "b" : "a");

/**
 * 最初の挨拶を api2026 から取得する。吹き出しの配列を返し、失敗したら null を返す。
 * 要素数は固定ではない (管理画面で行を増やせる) ので length に依存しないこと。
 * 失敗時にフロントの定型文へ差し替えてはいけない — 呼び出し側でエラー画面に落とす
 */
const fetchGreeting = async (pattern) => {
  const url = `${CONFIG.API2026_HOST}/api/fronts/${encodeURIComponent(CONFIG.FRONT_ID)}/greeting?pattern=${encodeURIComponent(pattern)}`;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), GREETING_TIMEOUT_MS);
  try {
    const res = await fetch(url, { signal: controller.signal });
    const raw = await res.text();
    let data;
    try {
      data = JSON.parse(raw);
    } catch (_) {
      return null;
    }
    if (!res.ok || !data.success || !data.data) return null;
    const bubbles = data.data.bubbles;
    if (!Array.isArray(bubbles)) return null;
    const cleaned = bubbles.filter(b => typeof b === "string" && b.trim() !== "");
    return cleaned.length ? cleaned : null;
  } catch (_) {
    return null;
  } finally {
    clearTimeout(timer);
  }
};

const startRestaurantIntake = async ({ skipGreeting = false } = {}) => {
  // 挨拶はインテークを組み立てる前に取りに行く。取れなければ中断してエラー画面へ
  let greeting = [];
  if (!skipGreeting) {
    greeting = await fetchGreeting(greetingPattern());
    if (!greeting) {
      await sceneManager("error");
      return;
    }
  }
  intake = {
    step: "person",
    awaitText: null,
    personLabel: "", personPhrase: "",
    areaLabel: "", areaPhrase: "",
    priceLabel: "", pricePhrase: "",
    optionLabel: "", optionPhrase: "",
    extraPhrase: "",
    // 各質問が確定済みかどうか。空文字も「未指定として確定」なので値では判定できない
    filled: { person: false, area: false, price: false, option: false },
    // 昼の予算を聞き直したか (何度も聞かないよう 1 回で打ち切る)
    lunchBudgetAsked: false,
    // 判定APIがステップごとに何回落ちたか。通算2回目から「決めずに進める」に落とす
    apiFailures: {},
  };
  intakeTraceId = newTraceId();
  // 出し分けはインテーク開始時に1回だけ決める (途中で挙動が変わらないように)
  intakeApiEnabled = CONFIG.INTAKE_API && (Math.random() * 100 < CONFIG.INTAKE_API_RATE);
  // 最後の1問 (人数の質問) はフロントのまま。API に判定を送るときの intake.question と
  // 同じ値なので、API 側にも持たせると同じ文言が2箇所になる
  await askNext([...greeting, INTAKE_MSG.askPerson], "person");
};

/**
 * インテーク中の静的選択肢ボタン押下を処理する
 */
const handleIntakeSelection = async (label, meta) => {
  if (!intake) {
    // インテーク外 (検索完了後など) に静的ボタンが押された場合はそのまま検索として送る
    await submitSearch(label);
    return;
  }
  addChatMessage(label, true);

  switch (intake.step) {
    case "person":
      intake.personLabel = label;
      // ボタンラベルをそのまま鉤括弧に入れて送る。サーバ (api2026 の queryAnalyzer.js
      // PARTY_SIZE_PATTERN) がこの形式を待ち受けており、「それ以上」→席数下限11、
      // 「〜10人」→6、「〜5人」「未定」→席数条件クリア、として解釈される。
      // 鉤括弧は必須 (無いとキャプチャが文末まで伸び、予算1万円台で誤判定になる)
      intake.personPhrase = `予定人数は「${label}」`;
      intake.filled.person = true;
      await goToNextStep();
      break;

    case "area":
      if (meta === "location_others") {
        // 「その他」→ エリア名の自由入力を待つ
        intake.awaitText = "area";
        await askNext([INTAKE_MSG.askAreaText], null);
        break;
      }
      intake.areaLabel = label;
      intake.areaPhrase = (meta === "tokyo") ? "東京駅周辺" : label;
      intake.filled.area = true;
      await goToNextStep();
      break;

    case "price":
      intake.priceLabel = label;
      if (meta === "budget_unknown") {
        // 予算で絞らない。予算データが登録されていない店舗 (東京で16.6%) も候補に入る
        intake.pricePhrase = "";
      } else if (meta === "budget_more") {
        // 「それ以上」= 金額ボタンの最上位より上。ボタンを増減したらここも合わせる
        intake.pricePhrase = "一人あたり予算は8,000円以上";
      } else {
        intake.pricePhrase = `一人あたり予算は${label.replace("〜", "")}まで`;
      }
      intake.filled.price = true;
      await goToNextStep();
      break;

    case "option":
      intake.optionLabel = label;
      intake.optionPhrase = (meta === "private_room") ? "個室あり"
        : (meta === "lunch") ? "お昼に行きたい"
        : "";
      intake.filled.option = true;
      await goToNextStep();
      break;

    case "confirm":
      if (meta === "search_reset") {
        // 条件をやり直す
        await startRestaurantIntake({ skipGreeting: true });
      } else {
        // OK → 収集した条件で検索実行 (合成メッセージはユーザー吹き出しには出さない)
        await submitSearch(buildSearchMessage(), { echo: false });
      }
      break;
  }
};

/**
 * インテーク判定を API に問い合わせる (検索は走らない)。
 * 8秒で打ち切り、intake 応答の session_id は採用しない (検索セッションを壊さないため)
 */
const callIntakeApi = async (message) => {
  const url = `${CONFIG.API2026_HOST}/api/fronts/${encodeURIComponent(CONFIG.FRONT_ID)}/chat`;
  const userId = getUserId();
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), INTAKE_TIMEOUT_MS);
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message,
        trace_id: intakeTraceId,
        ...(userId ? { user_id: userId } : {}),
        intake: {
          step: intake.step,
          question: stepQuestion(intake.step),
          collected: currentCollected(),
        },
      }),
      signal: controller.signal,
    });
    const raw = await res.text();
    let data;
    try {
      data = JSON.parse(raw);
    } catch (_) {
      return { ok: false, timeout: true };
    }
    if (!res.ok || !data.success) return { ok: false, error: data.error };
    // sessionId はここでは触らない (intake 応答は session_id を返さない取り決め)
    return { ok: true, data: data.data };
  } catch (err) {
    return { ok: false, aborted: err && err.name === 'AbortError' };
  } finally {
    clearTimeout(timer);
  }
};

/**
 * 判定に失敗したときの復帰。入力は取り込まない (条件を汚さないため)。
 * エリアだけは未指定で確定させると地域未確定の検索になるので聞き返しを続ける
 */
const handleIntakeFailure = async (step) => {
  $(".chat-thinking").remove();
  const myIntake = intake;
  const failures = (intake.apiFailures[step] || 0) + 1;
  intake.apiFailures[step] = failures;

  // 1回目は条件を確定させず、同じ質問を出し直す (送り直せばそのまま続けられる)。
  // エリアだけは確定させると地域未確定の検索になるので、回数によらず聞き返しを続ける
  if (step === "area" || failures < 2) {
    await askNext([INTAKE_FALLBACK_NETWORK], null);
    if (intake !== myIntake) return;
    await askStep(step);
    return;
  }
  // 通算2回目。未指定として確定する。表示と送信文はボタンの「未定」と同じ扱いに揃える
  if (step === "person") {
    intake.personLabel = "未定";
    intake.personPhrase = `予定人数は「未定」`;
  } else if (step === "price") {
    intake.priceLabel = "未定";
    intake.pricePhrase = "";
  }
  intake.filled[step] = true;
  await askNext([INTAKE_FALLBACK_SKIP], null);
  await goToNextStep();
};

/**
 * API の判定結果に従ってインテークを進める。
 * フロントは is_answer / collected / next を受けて適用するだけで、判定はしない
 */
const handleIntakeTextByApi = async (text) => {
  const askedStep = intake.step;
  const myIntake = intake;
  const mySeq = ++intakeSeq;
  isSending = true;
  $("#send-button").prop("disabled", true);
  addChatMessage("", false, true); // 考え中の吹き出し
  // このターンが最新かどうか。botSay で待つ間に次のターンが始まると、古いターンが
  // intake.step を巻き戻したり選択肢を二重表示したりするため、要所で必ず確認する
  const isStale = () => (mySeq !== intakeSeq || intake !== myIntake);
  let result;
  try {
    result = await callIntakeApi(text);
    // 端末側の単発の通信失敗が条件確定まで波及していたため、待たずに1回だけ送り直す。
    // 実測1.3〜1.6秒なので体感に出ない。2回に留めるのは全断のときに粘りすぎないため。
    // ok だが intake を含まない応答 (検索結果が返った等) は再送しない
    if (!result.ok) result = await callIntakeApi(text);

    // タイムアウト後に遅れて返った応答や、リセットでインテークが作り直された場合は捨てる
    if (isStale()) return;

    // 判定不能 (通信失敗・タイムアウト) と、API が intake を解さない場合は同じ扱いにする。
    // 後者は検索結果が返ってきてしまうため、吹き出しを出さずにフォールバックする
    if (!result.ok || !result.data || !result.data.intake) {
      await handleIntakeFailure(askedStep);
      return;
    }

    const data = result.data;
    const info = data.intake;
    const bubbles = Array.isArray(data.comment_bubbles) ? data.comment_bubbles : [];
    if (bubbles.length) {
      await botSay(bubbles);
      if (isStale()) return;
    } else {
      $(".chat-thinking").remove();
    }
    await applyIntakeResult(askedStep, info, bubbles, isStale);
  } finally {
    // 解放は最後に行う。早く外すと、次の遷移 (検索実行など) が submitSearch の
    // 多重送信ガードに弾かれて無反応になる
    isSending = false;
    $("#send-button").prop("disabled", false);
  }
};

/** API の判定結果 (next) をインテークの状態に適用する */
const applyIntakeResult = async (askedStep, info, bubbles, isStale) => {
  if (isStale()) return;
  const next = info.next || (info.is_answer ? "advance" : "repeat");
  if (next === "restart") {
    await startRestaurantIntake({ skipGreeting: true });
    return;
  }
  if (next === "back") {
    // API が back_to で戻り先を指定してくる場合はそれに従う。
    // 無い場合のみ従来どおり「1つ前」(確認ステップからは最後の質問) に戻す
    const idx = STEP_ORDER.indexOf(askedStep);
    const fallback = (askedStep === "confirm")
      ? STEP_ORDER[STEP_ORDER.length - 1]
      : (idx > 0 ? STEP_ORDER[idx - 1] : askedStep);
    const prev = STEP_ORDER.includes(info.back_to) ? info.back_to : fallback;
    intake.filled[prev] = false;
    await askStep(prev);
    return;
  }
  if (next === "search") {
    // 確認ステップで「OK」相当。条件は一切変えずにそのまま検索する。
    // submitSearch は自前の多重送信ガードを持つため、先に解放しないと弾かれて無反応になる
    isSending = false;
    await submitSearch(buildSearchMessage(), { echo: false });
    return;
  }
  if (next === "advance" && info.is_answer) {
    // collected に入っている項目だけを上書きする (追加ではない)
    applyCollected(info.collected);
    if (askedStep === "confirm") {
      // 条件が変わったので確認画面を出し直す
      await goToConfirm();
    } else {
      await goToNextStep();
    }
    return;
  }
  // repeat: 確認ステップでは条件サマリを必ず出し直す。
  // 「条件を更新したナ」と言われても実際には反映されていないことがあるため、
  // 画面のサマリで確定値を確認できるようにしておく
  if (askedStep === "confirm") {
    await goToConfirm({ sayAsk: bubbles.length === 0 });
    return;
  }
  // 質問の再掲は API 側の吹き出しに含まれるので、選択肢だけ出し直す
  await askStep(askedStep, { say: bubbles.length === 0 });
};

/**
 * インテーク中の自由入力を処理する。
 * INTAKE_API が有効なら API に「今の質問への回答か / 雑談か」を判定させ、返ってきた
 * next (advance / repeat / back / restart) に従うだけにする。
 * 無効なら従来どおりクライアント側で「現在の質問への回答」として取り込む
 */
const handleIntakeText = async (text) => {
  addChatMessage(text, true);
  // 確認ステップ (Phase 2) も含めて API に判定させる
  if (intakeApiEnabled) {
    await handleIntakeTextByApi(text);
    return;
  }
  switch (intake.step) {
    case "person":
      intake.personLabel = text;
      intake.personPhrase = `人数は${text}`;
      intake.step = "area";
      intake.awaitText = "area";
      await askNext([INTAKE_MSG.askArea], null);
      break;
    case "area":
      intake.awaitText = null;
      intake.areaLabel = text;
      intake.areaPhrase = text;
      intake.step = "price";
      await askNext([INTAKE_MSG.askPrice], "price");
      break;
    case "price":
      intake.priceLabel = text;
      intake.pricePhrase = `予算は${text}`;
      intake.step = "option";
      await askNext([INTAKE_MSG.askOption], "option");
      break;
    case "option":
      intake.optionLabel = text;
      intake.optionPhrase = text;
      intake.step = "confirm";
      await askNext([buildConfirmMessage(), INTAKE_MSG.confirmAsk], "search");
      break;
    case "confirm":
      // 確認画面での自由入力は追加条件として合成し、そのまま検索を実行する
      intake.extraPhrase = text;
      await submitSearch(buildSearchMessage(), { echo: false });
      break;
  }
};

const buildConfirmMessage = () => {
  return `この条件で探すゾ！\n【エリア】${intake.areaLabel || "未指定"}\n【人数】${intake.personLabel || "未定"}\n【予算】${intake.priceLabel || "未指定"}\n【こだわり】${intake.optionLabel || "特になし"}`;
};

/**
 * インテークの回答とスワイプ診断結果を自然言語の検索メッセージに合成する
 */
const buildSearchMessage = () => {
  let message = "";
  if (intake.areaPhrase) {
    message += `${intake.areaPhrase}でお店を探して。`;
  } else {
    message += "お店を探して。";
  }
  const conditions = [intake.personPhrase, intake.pricePhrase, intake.optionPhrase, intake.extraPhrase].filter(Boolean);
  if (conditions.length) {
    message += `${conditions.join("、")}。`;
  }
  const choice = getTopChoice();
  if (choice) {
    message += `雰囲気は「${choice}」が好み。`;
  }
  return message;
};

/**
 * スワイプ診断で最もスコアの高いカテゴリを返す (未診断・スコア0以下は空文字)
 */
const getTopChoice = () => {
  const sorted = getSortedCategories().filter(c => c.category !== "その他");
  if (!sorted.length || sorted[0].score <= 0) return "";
  return sorted[0].category;
};

// ==============================================
// ボタン設定
// ==============================================
/* Button Settings */
const settingButtons = ()=>{
  // Error
  $("#reload-page").on("click",(e)=>{
    e.preventDefault();
    location.reload();
    return false;
  });
  // TERMS (フリック画面に重ねて出す規約モーダル)
  // 閉じるのは hide を付けるだけ。sceneManager は全 section を hide にするので、
  // ここで使うと背面のフリック画面まで消えてしまう
  $("#next-scene").on("click",(e)=>{
    e.preventDefault();
    if ($("#terms").hasClass("hide")) return false; // 二重起動しない
    $("#terms").addClass("hide");
    sendPageView("MATCHING","/matching");
    return false;
  })
  // MATCHING
  $("#skip-match").on("click",(e)=>{
    e.preventDefault();
    if ($("#matching").hasClass("hide")) return false; // 遷移済みなら二重起動しない
    sceneManager("chat");
    return false;
  });
  // 直接送信
  $("#send-button").on("click",async (e)=>{
    if (isSending) return;
    const string = $("#chat-input").val().trim();
    if(string === "") return;
    $("#chat-input").val("").css('height', '46px');
    $("#send-button").removeClass("active");
    $("#chat-input").removeClass("active");
    await optionManager("hide");
    $("#chat-content-inner").removeClass("multiple-options");

    // インテーク中の自由入力は「現在の質問への回答」として取り込み、条件を引き継ぐ
    if (intake) {
      await handleIntakeText(string);
      return;
    }
    // インテーク終了後 (検索開始後) の自由入力はそのまま新APIへ送信
    await submitSearch(string);
  });

  $("#chat-input").on("focus", (e)=>{
    $("#chat").addClass("focus");
  });
  $("#chat-input").on("blur", (e)=>{
    $("#chat").removeClass("focus");
  });
  $("#chat-input").on("input", (e)=>{
    const input = e.target;
    input.style.height = 'auto';
    input.style.height = (input.scrollHeight-22) + 'px';
    if(input.value.trim() === ""){
      $("#chat-input").removeClass("active");
      $("#send-button").removeClass("active");
    } else {
      $("#chat-input").addClass("active");
      $("#send-button").addClass("active");
    }
  });

  // 静的選択肢ボタン (インテーク)
  $(".option-button").on("click", async (e)=>{
    if (isSending) return;
    const $target = $(e.currentTarget);
    if( $target.hasClass("back") ){
      await optionManager("hide");
      await optionManager("area");
      return;
    }
    if ( $target.hasClass("area") && $target.attr("data-area") ){
      await optionManager("hide");
      await optionManager($target.attr("data-area"));
      return;
    }

    const label = $target.text();
    let meta = "";
    if($target.data("meta") !== undefined){
      meta = $target.data("meta");
    }
    await optionManager("hide");
    $("#chat-content-inner").removeClass("multiple-options");

    await handleIntakeSelection(label, meta);
  });

  // サーバ駆動の動的選択肢ボタン (clarification / actions)
  $(".button-group.dynamic").on("click", ".option-button", async (e)=>{
    if (isSending) return;
    const $target = $(e.currentTarget);
    await optionManager("hide");
    $("#chat-content-inner").removeClass("multiple-options");

    if ($target.attr("data-local-action") === "retry") {
      // リトライ: 元メッセージは表示済み (またはインテーク合成文で非表示設計) のため再エコーしない
      await submitSearch(lastSentMessage, { echo: false });
      return;
    }
    const label = $target.text();
    const resend = $target.attr("data-resend") || label;
    if (label.includes("もっと探して")) {
      sendEvent('restaurants_suggest_completed_more');
    } else {
      sendEvent('action_button_click', { 'event_label': label });
    }
    // 押下されたボタンの resend_message をそのまま再送する (doc/13 パターンB/C)。
    // 表示だけはラベルにする (地域確認の resend_message は元クエリ全文を含むため)
    await submitSearch(resend, { echoAs: label });
  });

  $('body').on('click', '.tab-link' , function(e) {
    sendEvent('link_click', {
      'event_category': 'tabele_link',
      'event_label': 'external_link',
      'link_url': e.currentTarget.href || '',
      'value': e.currentTarget.href || '',
      'restaurant_name': e.currentTarget.getAttribute('data-name') || ''
    });
  });
  $('body').on('click', '.tel' , function(e) {
    sendEvent('link_click', {
      'event_category': 'tabele_tel',
      'event_label': 'external_link',
      'link_url': e.currentTarget.href || '',
      'value': e.currentTarget.href || '',
      'restaurant_name': e.currentTarget.getAttribute('data-name') || ''
    });
  });

};

const optionManager = async (action) => {
  switch( action ){
    case "price":
      $(".option-button-container").addClass("price");
      $(".option-button-container").addClass("active");
      break;
    case "area":
      $("#chat-content-inner").addClass("multiple-options");
      $(".option-button-container").addClass("area");
      $(".option-button-container").addClass("active");
      break;
    case "area1":
      $(".option-button-container").addClass("area1");
      $(".option-button-container").addClass("active");
      break;
    case "area2":
      $(".option-button-container").addClass("area2");
      $(".option-button-container").addClass("active");
      break;
    case "area3":
      $(".option-button-container").addClass("area3");
      $(".option-button-container").addClass("active");
      break;
    case "area4":
      $(".option-button-container").addClass("area4");
      $(".option-button-container").addClass("active");
      break;
    case "area5":
      $(".option-button-container").addClass("area5");
      $(".option-button-container").addClass("active");
      break;
    case "area6":
      $(".option-button-container").addClass("area6");
      $(".option-button-container").addClass("active");
      break;
    case "area7":
      $(".option-button-container").addClass("area7");
      $(".option-button-container").addClass("active");
      break;
    case "area8":
      $(".option-button-container").addClass("area8");
      $(".option-button-container").addClass("active");
      break;
    case "person":
      $(".option-button-container").addClass("person");
      $(".option-button-container").addClass("active");
      break;
    case "option":
      $(".option-button-container").addClass("option");
      $(".option-button-container").addClass("active");
      break;
    case "search":
      $(".option-button-container").addClass("search");
      $(".option-button-container").addClass("active");
      break;

    case "hide":
      $(".option-button-container").removeClass("active");
      await sleep(300);
      $(".option-button-container").removeClass("price place person option area area1 area2 area3 area4 area5 area6 area7 area8 search dynamic wrap");
      break;
  }
}


// ==============================================
// Swiper関連
// ==============================================
const swiperInit = () => {
  // Swiper初期化（.swiperセレクタを指定）
  const swiper = new Swiper('.swiper', {
    // pass EffectTinder module to modules
    modules: [Autoplay, Navigation, Pagination, EffectTinder],
    // specify "tinder" effect
    effect: 'tinder',
    on: {

      tinderSwipe(s, direction) {
        if(s.activeIndex === 0) return; // 最初のスライドはカウントしない

      const category = Number(s.slides[s.previousIndex].dataset.cate);
      const subcategory = Number(s.slides[s.previousIndex].dataset.sub);
      categories[category].score += (direction === "right") ? 2 : -1;
      if(subcategory !== undefined && !isNaN(subcategory)){
        categories[subcategory].score += (direction === "right") ? 1 : 0;
      }
      if(s.activeIndex === s.slides.length -1){
        // 最後のスライドまで到達

        const sortedCategories = getSortedCategories();
        let categoryList = "";
        sortedCategories.forEach((cate, index) => {
          if(index > 0){ categoryList += ","};
          categoryList += "'" + cate.category + "'";
        });
        localStorage.setItem("choices", categoryList);

        setTimeout(() => {
          if ($("#matching").hasClass("hide")) return; // SKIP等で遷移済みなら二重起動しない
          sceneManager("chat");
        }, 500); // 少し遅延させてから戻る

      }
    },
  },
    // other parameters
  });

  // 各スライドの座標と傾きを配列で設定（スライドごとに固定の値）
  const slideTransforms = [
    { x: 0, y: 0, deg: 0 },
    { x: -10, y: -10, deg: -10 },
    { x: 20, y: 20, deg: 10 },
    { x: 0, y: -10, deg: 3 },
    { x: 2, y: 10, deg: -10 },
    { x: 0, y: -10, deg: 30 },
    { x: 3, y: 10, deg: -15 },
    { x: 0, y: -20, deg: 15 },
    { x: -20, y: 20, deg: -10 },
    { x: 5, y: -10, deg: 10 }
  ];

  // 初回のみ：各スライドに固定の座標と傾きを設定
  swiper.slides.forEach((slide, index) => {
    const picture = slide.querySelector('picture');
    if (!picture) return; // pictureがない場合はスキップ

    // 各スライドに配列で指定した値を設定
    const transform = slideTransforms[index] || { x: 0, y: 0, deg: 0 };
    picture.style.transform = `translate(${transform.x}px, ${transform.y}px) rotateZ(${transform.deg}deg)`;

    // 初期値を保存（後で参照するため）
    picture.dataset.initialTransform = JSON.stringify(transform);
  });

  // スライドが最上部（アクティブ）になったときだけ0にリセット
  swiper.on('slideChange', () => {
    swiper.slides.forEach((slide, index) => {
      const picture = slide.querySelector('picture');
      if (!picture) return;

      if (index === swiper.activeIndex) {
        // 最上部になったら座標と角度を0に
        picture.style.transform = `translate(0px, 0px) rotateZ(0deg)`;
      } else {
        // それ以外は初期値に戻す
        const initialTransform = JSON.parse(picture.dataset.initialTransform || '{"x":0,"y":0,"deg":0}');
        picture.style.transform = `translate(${initialTransform.x}px, ${initialTransform.y}px) rotateZ(${initialTransform.deg}deg)`;
      }
    });
  });
  window.swiper = swiper;

  $("#overlay-modal .accept").on("click", async () => {
    sendEvent('execute_reset');

    localStorage.setItem("choices", "");
    resetCategoriesScore();
    swiper.slideTo(0, 0);
    $(".swiper-tinder-button").removeClass("swiper-tinder-button-hidden"); //
    sceneManager("matching");
    await optionManager("hide");
    $("#overlay-modal").removeClass("active");
    // 新APIのセッションを破棄 (次回検索から新規セッション)
    sessionId = null;
    lastSentMessage = "";
    intake = null;

    $("#chat-content-inner").empty();
    $("#chat-content-inner").removeClass("multiple-options");
    addChatMessage("", false,true)
  });
  $("#overlay-modal .cancel").on("click", async () => {
    $("#overlay-modal").removeClass("active");
  });
  $("#swiper-reset").on("click", async () => {
    $("#overlay-modal").addClass("active");
  });

}

/**
 * categoriesの全scoreを0にリセットする
 */
const resetCategoriesScore = () => {
  categories.forEach(category => {
    category.score = 0;
  });
};

/**
 * categoriesをディープコピーしてscoreで降順にソートする
 * @returns {Array} ソート済みのカテゴリー配列
 */
const getSortedCategories = () => {
  // JSON.parse/stringifyでディープコピー
  const copiedCategories = JSON.parse(JSON.stringify(categories));

  // scoreで降順ソート
  return copiedCategories.sort((a, b) => b.score - a.score);
};


// ==============================================
// アプリケーション起動
// ==============================================

$(async () => {
  localStorage.setItem("choices", "");
  // 初期表示は「フリック画面＋規約モーダル」。旧LPは廃止したので、ここが最初の画面になる
  sendPageView("TERMS","/terms");
  if (CONFIG.LOGIN) {
    if (CONFIG.REQUIRE_LIFF_BROWSER) {
      // LIFFブラウザ以外を弾くビルド。判定が出るまで待ち、外部ブラウザなら
      // フリックもボタンも初期化しない (案内だけが残る)
      if (await liffInit()) return;
    } else {
      // 従来どおり待たずに走らせる (初期表示を遅らせない)
      liffInit();
    }
  }
  settingButtons();
  swiperInit();
});
